module.exports = __webpack_public_path__ + "img/logo_dianxin.8be2e03f.png";